<div>
  <h2 class="settings-title">{{ "plan.ct.settings.fte.section.header" | translate }}</h2>
  <div>
    <div class="hours-per-day input-label">
      {{ "plan.ct.settings.fte.hours.per.day" | translate }}
    </div>
    <div class="time-picker-container">
      <sol-time-picker #hrsPerDayPicker data-testid="hrsperday"
                         [steps]="15"
                         (timeChanged)="onHoursPerDayChange($event)"
                         [label]="'plan.ct.settings.fte.hours.per.day' | translate"
                         [format]="'hh:mm'"
                         [minTime]="this.hrsPerDayStartDate"
                         [maxTime]="this.hrsPerDayEndDate"
                         [disableTextInput]="false">
      </sol-time-picker>
      <span class="side-label" *ngIf="this.hrsPerDayModel.value==='--:--' && this.hrsPerDayModel.isValid"> {{"plan.ct.settings.multiple.values"|translate}}</span>
    </div>
    <div *ngIf="!hrsPerDayModel.isValid" class="error-message">{{hrsPerDayModel.validationMessage|translate}}</div>

    <div class="hours-per-week input-label">
      {{ "plan.ct.settings.fte.hours.per.week" | translate }}
    </div>
    <div class="time-picker-container">
      <sol-time-picker #hrsPerWeekPicker data-testid="hrsperweek"
                         [steps]="this.hrsPerWeekStep"
                         (timeChanged)="onHoursPerWeekChange($event)"
                         [label]="'plan.ct.settings.fte.hours.per.week' | translate"
                         [format]="'hh:mm'"
                         [minTime]="this.hrsPerWeekStartDate"
                         [maxTime]="this.hrsPerWeekEndDate"
                         [disableTextInput]="false">
      </sol-time-picker>
      <span class="side-label" *ngIf="this.hrsPerWeekModel.value==='--:--' && this.hrsPerWeekModel.isValid"> {{"plan.ct.settings.multiple.values"|translate}}</span>
    </div>
    <div *ngIf="!hrsPerWeekModel.isValid" class="error-message" data-testid="hrsperweekvalidation">
      {{hrsPerWeekModel.validationMessage|translate}}
    </div>
  </div>
  <div>
    <form [formGroup]="monthsForm">
      <table class="inputs-table">
        <thead>
        <tr>
          <th scope="col" class="text-uppercase">{{'plan.ct.settings.month' | translate}}</th>
          <th scope="col" class="text-uppercase">{{'plan.ct.settings.days' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let month of months; let i = index">
          <th scope="row" class="text-uppercase">
            <span class="month-label">
              {{ getMonthName(i)}}
            </span>
          </th>
          <td>
            <div>
              <input class="p-inputtext p-component p-element p-inputnumber-input p-inputnumber" [type]="monthType[month]" [formControlName]="month" [min]="1" [max]="monthMaxDays[month]" (input)="onMonthEdit(month)" [attr.aria-label]="getMonthName(i)">
              <span class="side-label" *ngIf="monthsForm.get(month).pristine==true && monthsForm.get(month).value=='--'">{{"plan.ct.settings.multiple.values"|translate}}</span>
            </div>
            <!--<div *ngIf="!hrsPerDayModel.isValid" class="error-message">{{hrsPerDayModel.validationMessage|translate}}</div>-->
            @if (monthsForm.get(month).pristine==false && monthsForm.get(month).invalid) {
              <div class="error-message">
                {{"plan.ct.settings.fte.months.validation" | translate: {'0':monthMaxDays[month]} }}
              </div>
            }
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
